//コード加工など商品ページからは購入させたくないページに使用するjs
//トップページにリダイレクトさせる

// トップページのURL
const topPageUrl = window.location.origin;

// 現在のページのURL
const currentUrl = window.location.href;

// もし現在のページがトップページでなければリダイレクト
if (currentUrl !== topPageUrl) {
    window.location.replace(topPageUrl);
}